import React from "react";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import "../list.css";
import {Icon, Grid,Tab, Label, Accordion,List,Message, Menu,Step, Image,Segment,Header,Button,Divider,Input,Modal,Form,TextArea ,Pagination, Checkbox,Radio,Item} from 'semantic-ui-react'
import Select from "react-select";
import Table from 'react-bootstrap/Table'
import axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBCard,
  MDBCardBody
} from "mdbreact";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import { timeWednesday } from "d3";
import { API_BASE_URL } from "../utils/endpoints";
//import Modal from "react-modal";

const modDelete ={
  marginTop: 200,
  marginLeft:'30%',
  height:'auto',
  textAlign:'left'
}

const modDeletea ={
  marginTop: 200,
  marginLeft:'15%',
  height:'auto',
  textAlign:'left'
}

const modEdit ={
  marginTop: 100,
  marginLeft:'30%',
  height:'auto',
  textAlign:'left'
}

const modEdita ={
  marginTop: 100,
  marginLeft:'15%',
  height:'auto',
  textAlign:'left'
}

const modAdd ={
  marginTop: 200,
  marginLeft:'30%',
  height:'auto',
  textAlign:'left'
}

const modAdda ={
  marginTop: 200,
  marginLeft:'15%',
  height:'auto',
  textAlign:'left'
}

const modContact ={
  marginTop: 70,
  marginLeft:'25%',
  height:'auto',
  textAlign:'left'
}
const modContacta ={
  marginTop: 70,
  marginLeft:'15%',
  height:'auto',
  textAlign:'left'
}


var categoryOptions = [];
var countryOptions=[];
var value_options=[]
var group_data=[]

const customStyles = {
  content: {
    left: "13%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%"
  }
};
const formData = new FormData();
class Group extends React.Component {
  state = { activeIndex: 0 };
  constructor(props) {
    super(props);
    this.state = {
      persons: [],
      groups: [],
      group_contact: [],
      uploadfile: [],
      options: [],

      groupcontacttotalpage: 1,
      searchgroupcontacttotalpage: 1,


      modalIsOpenContact: false,
      modalIsOpenDelete: false,
      personsContact: [],
      personssearch: [],
      totalpage: 1,
      activePage: 1,
      contactsearchtotalpage:1,
      allContacts: [],
      contactsIDs: {},
      groupName: "",
      groupID: "",
      addContactObject: {},
      groupIdForeDelet: "",
      groupNameForeDelete: "",
      modalIsOpenDeleteCategory: false,
      CategoryIdForeDeletCategory: "",
      CategoryNameForeDeleteCategory: "",
      totalpageGroup: "1",
      activePageGroup: 1,

      modalOpen: false,
      modalOpenAddGroup: false,
      modalOpenEditGroup: false,
      modalOpenDeleteGroup: false,
      modalOpenImportFromFile: false,
      modalOpenImportFromContact: false,
      modalOpenGroupsContacts: false,
      contactCount:0,



      //////////// from add group //////////////
      groupName: '',
      selectedValues: [],
      categoryselect:'',
      category_id:'',
      options_sender:[],

      ////////////////////// from edit group/////////
    
    total_group_contacts:[],
    group_name:'',
    total_group_contacts:0,
    group_contact:[],
    group_id:'',
    totalpage:1,
    activePage: 1,
    group_datas:'',
    name_category:''
    };
    this.sendAll = this.sendAll.bind(this);
    this.openModalContact = this.openModalContact.bind(this);
   
    this.addContactList = this.addContactList.bind(this);
   
  }

  handleOpenAddGroup = () => this.setState({ modalOpenAddGroup: true })
  handleCloseAddGroup = () => this.setState({ modalOpenAddGroup: false })
  handleOpenEditGroup = () => this.setState({ modalOpenEditGroup: true })
  handleCloseEditGroup = () => this.setState({ modalOpenEditGroup: false })
  handleOpenDeleteGroup = () => this.setState({ modalOpenDeleteGroup: true })
  handleCloseDeleteGroup = () => this.setState({ modalOpenDeleteGroup: false })
  handleOpenImportFromFile = () => this.setState({ modalOpenImportFromFile: true })
  handleCloseImportFromFile = () => this.setState({ modalOpenImportFromFile: false })
  handleOpenImportFromContact = () => this.setState({ modalOpenImportFromContact: true })
  handleCloseImportFromContact = () => this.setState({ modalOpenImportFromContact: false })
  handleOpenGroupsContacts = () => this.setState({ modalOpenGroupsContacts: true })
 handleCloseGroupsContacts = () => this.setState({ modalOpenGroupsContacts: false })



  handlePaginationChangeGroup = (e, { activePage }) => {
    this.setState({ activePage })
    var token = reactLocalStorage.get("accessToken");
   // window.scrollTo(0, 0);
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num= activePage -1;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/findAllGroups/"+page_num;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/findAllGroups/"+page_num;
    }
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      const groups = res.data.result.groups;
      var total=Math.ceil(res.data.result.totalGroupsCount/20);
      this.setState({totalpage:total})

      if (groups != undefined) {
        this.setState({ groups });
      }
    });
  };

  componentWillMount() {
    var token = reactLocalStorage.get("accessToken");
    reactLocalStorage.get("user_id_login");
    var page_num = this.state.activePage - 1;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        page_num +
        "/findallcontacts";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        page_num +
        "/findallcontacts";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      const personsContact = res.data.result.contacts;

      if (res.data.result.contacts !== []) {
        this.setState({ personsContact });
      }
    });
    //this.AddGroup()
  }


  findContactInGroup  = event => {
    var  group_id= event.target.id
    reactLocalStorage.set("group_id", group_id)
    console.log(group_id)
    this.setState({modalOpenGroupsContacts:true})
    var token=reactLocalStorage.get('accessToken');
    var ip=API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page=0;
    if(ip.includes(s2))
    {
     apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('group_id')+"/"+page;     
    }
    else
    {
     apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('group_id')+"/"+page;
    }

    var headers = {'Content-Type': 'application/json', 'token' :token }
    axios.get(apiBaseUrl,{headers: headers})
        .then(res => {
          const persons = res.data.result.group;
          var array=[];
          if(persons !== undefined)
          {
            array.push({
              label:'',
              value:'null'
             })
             this.setState({group_id:res.data.result.group.group_id})
            this.setState({group_name:res.data.result.group.group_name})
            this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
            var total=Math.ceil(res.data.result.group.total_group_contacts / 10);
            this.setState({totalpage:total})
         
            if(res.data.result.group.total_group_contacts === 0)
            {
            
              this.setState({contactCount:0})
           // document.querySelector('.view_details_group').style = 'display:none';
            }
           this.setState({group_contact: res.data.result.group.group_contacts});
         
        
         this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
     
         const newArr=[]
         if(res.data.result.group.category !== null)
         { newArr.push({
           label: res.data.result.group.category.category_name, 
           value:res.data.result.group.category.category_id
       });
       if(res.data.result.group.category.category_name !== '') 
       {
         this.setState({name_category:res.data.result.group.category.category_name})

       }
       else{
          this.setState({name_category:'Select ...'})
       }
       value_options= newArr;
       this.setState({group_datas : res.data.result.group.category.category_id});
       group_data = res.data.result.group.category.category_id
         }
        
       
       this.setState({groupName:this.state.groupName})
 
          }
        }) 
  }


  handleClick = (e, titleProps) => {
   // this.setState({modalOpenGroupsContacts:true})
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });

    var id = e.target.id;
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/findAllGroups";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/findAllGroups";
    }
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      const groups = res.data.result.groups;
      var i;
      for (i = 0; i < groups.length; i++) {
        if (res.data.result.groups[i].group_id === id) {
          this.setState({
            group_contact: res.data.result.groups[i].group_contacts
          });

          this.setState({
            total_group_contacts: res.data.result.groups[i].total_group_contacts
          });
        }
      }
    });
  };
  openModalContact() {
    this.setState({ modalIsOpenContact: true });
  }
  openModalDelete = event => {
    this.setState({
     modalOpenDeleteGroup: true,
      groupIdForeDelet: event.target.id,
      groupNameForeDelete: event.target.name
    });
  }
  
  addContactList = event => {
    var contactID = event.target.id;
    if (this.state.contactsIDs.hasOwnProperty(contactID) === false) {
      this.state.contactsIDs[contactID] = contactID;
    } else {
      delete this.state.contactsIDs[contactID];
      
    }
  };

  sendAll() {
    for (let value of Object.values(this.state.contactsIDs)) {
      this.state.allContacts.push(value);
    }

    var data = {
      arrayOfContactsId: this.state.allContacts,
      group: { group_name: this.state.groupName, group_id: this.state.groupID }
    };

    var ip = API_BASE_URL;
    var token = reactLocalStorage.get("accessToken");
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/contacts/${reactLocalStorage.get( "user_id_login" )}/UpdateContacts/`;
    } else {
      apiBaseUrl =
        API_BASE_URL +`/core/user/rest/contacts/${reactLocalStorage.get( "user_id_login" )}/UpdateContacts/`;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status == "no sufficient balance") {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: "user created but" + " " + response.data.status,
              animation: "bounce",
              time: 3000
            });
          } else if (response.data.status == "falid") {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: response.data.result.ErrorDescription,
              animation: "bounce",
              time: 3000
            });
          }
          else{
            window.location="group"
          }
          setTimeout(function() {
            // window.location = "addsubadmin";
          }, 3000);
        } else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: 'error',
            title: i18n.t('error.label'),
            description:i18n.t('Something_wrong.label'),
            animation: 'bounce',
            time: 5000,

        });
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:i18n.t('Something_wrong.label'),
          animation: 'bounce',
          time: 5000,

      });
      });
this.setState({modalOpenImportFromContact:false})
    
  }

  searchchange = event => {
    if (event.target.value.length >= 2) {
   //   document.querySelector(".view_basic").style = "display:none";
    //  document.querySelector(".view_search").style = "display:block";
      var token = reactLocalStorage.get("accessToken");

      reactLocalStorage.get("user_id_login");

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/" +
          event.target.value +
          "/searchContacts";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/" +
          event.target.value +
          "/searchContacts";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then(res => {
        if (res.data.result.contacts != undefined) {
          const personssearch = res.data.result.contacts;
          this.setState({ personssearch });
        }
      });
    }
  };

 
  
 
  addContact = e => {
    // document.querySelector(".contact_list_div").style = "display:block";
    this.setState({ modalOpenImportFromContact: true });
    this.setState({ groupID: e.target.id });
    this.setState({ groupName: e.target.name });
  };

 
  DeletGroup = event => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");

    this.setState({ id: event.target.id });
    var data = "";
    var id_user = this.state.groupIdForeDelet;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/deleteGroup/"+id_user
       
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/deleteGroup/"+id_user 
        
    }
    var headers = {
      "Content-Type": "application/json",
      token: token
    };
    axios
      .post(apiBaseUrl,{} ,{ headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            window.location = "group";
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: 'error',
            title: i18n.t('error.label'),
            description:i18n.t('Something_wrong.label'),
            animation: 'bounce',
            time: 5000,

        });
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:i18n.t('Something_wrong.label'),
          animation: 'bounce',
          time: 5000,

      });
      });
  };

  state = {
    groups: [],
    isLoading: true,
    errors: null,
    id: "",
    group_contact: [],
    isArabic: false
  };

  getUsers() {
    //to get category list
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var page_num = this.state.activePage - 1;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/findAllCategories";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/findAllCategories";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      const persons = res.data.result.Categories;
      if (persons != undefined) {
        this.setState({ persons });
      }
    });

    //to get groups list
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num=this.state.activePageGroup -1;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/findAllGroups/"+page_num;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/findAllGroups/"+page_num;
    }
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      const groups = res.data.result.groups;
    
      var total=Math.ceil(res.data.result.totalGroupsCount/20);
      this.setState({totalpage:total})

      if (groups != undefined) {
        this.setState({ groups });
      }
    });
  }
  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
    
      document.querySelector(".pink_color").style =
        "text-align:right;width: 20%;white-space: pre;";
  
    
      document.querySelector(".fixed_group").style =
        "margin-right: 0% !important;";
    } 
    this.getUsers();
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      document.querySelector(".add_btn_group").style = "display:none";
    }
  }

  ImportGroup = event => {
    reactLocalStorage.set("import_id", event.target.id);
    

   /*  document.querySelector(".pans").style = "display:none";
    document.querySelector(".import_group").style = "display:block"; */
    this.setState({modalOpenImportFromFile:true})
  };
  handleChangeFile = event => {
    event.preventDefault();
    const newArr = this.state.uploadfile;
    newArr.push(event.target.files[0]);
    this.setState({
      uploadfile: newArr
    });

    formData.append("file", event.target.files[0]);
  };
  ImportGroupdata = event => {
    event.preventDefault();
    
    document.getElementById("group_import_btn").disabled = true;
    document.getElementById("group_import_btn").innerHTML = i18n.t("upload_in_progress.label");
    document.getElementById("group_import_btn").style = 'color:white;font-weight:bold;;';
    //document.getElementById("back_import_btn").style = 'line-height: 3.1;';
    var token = reactLocalStorage.get("accessToken");
    
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/" +
        reactLocalStorage.get("import_id") +
        "/importContactToGroup";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/" +
        reactLocalStorage.get("import_id") +
        "/importContactToGroup";
    }
    var data = formData;
    var headers = {
      "Content-Type": "multipart/form-data",
      token: token
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
 
        if (response.status === 200) {
          if (response.data.status == "success") {
            window.location = "group";
          }

          if (response.data.status == "failed") {
            toast({
              type: 'error',
              title: i18n.t('error.label'),
              description:response.data.result.result,
              animation: 'bounce',
              time: 5000,
    
          });
            document.getElementById("group_import_btn").disabled = false;
            document.getElementById("group_import_btn").innerHTML = i18n.t("Submit.label");
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        
            document.getElementById("group_import_btn").disabled = false;
            document.getElementById("group_import_btn").innerHTML = i18n.t("Submit.label");
            toast({
              type: 'error',
              title: i18n.t('error.label'),
              description:i18n.t('Something_wrong.label'),
              animation: 'bounce',
              time: 5000,
  
          });
        } else {
          console.log("Something wrong");
         
        document.getElementById("group_import_btn").disabled = false;
        document.getElementById("group_import_btn").innerHTML = i18n.t("Submit.label");
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:i18n.t('Something_wrong.label'),
          animation: 'bounce',
          time: 5000,

      });
      });

      this.setState({modalOpenImportFromFile:false})
  };

  ////////////// from add group //////////////////////
  onChange(values) {

    this.setState({
      selectedValues: values.id
    });
  }
  handleChangeAddGroup = event => {
    this.setState({ groupName: event.target.value});

  }
  AddGroup = () => {
    //window.location = "AddGroup";
    
    this.setState({modalOpenAddGroup:true})
    var lang=i18n.language;
    if(lang ==="ar")
    {
      //document.querySelector('.title_group').style = 'text-align:right;';       
  
    
    }
    var token=reactLocalStorage.get('accessToken');
    var ip=API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if(ip.includes(s2))
    {
     apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/findAllCategories";     
    }
    else
    {
     apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/findAllCategories";
    }

    var headers = {'Content-Type': 'application/json', 'token' :token }
 axios.get(apiBaseUrl,{headers: headers})
     .then(res => {
 
       if(res.data.result.Categories !== undefined)
         {
           const dataoption=res.data.result.Categories;
           var length=res.data.result.Categories.length;
           var i;
           const newArr = this.state.options_sender;
           for(i=0;i<length;i++)
           {
            var value_option=dataoption[i].category_name;

            newArr.push({
               label: value_option, 
               value:dataoption[i].id
           });
             
           }
           categoryOptions= newArr;
        }
      
      })
    }

    onChangecategory= event =>{
      this.setState({categoryselect: event.label}, function () {
     });
     this.setState({category_id: event.value}, function () {
    });
  };


  /* handleChange = event => {
    this.setState({ groupName: event.target.value});

  } */

  handleSubmitAddGroup = event => {
     event.preventDefault();
     if(this.state.category_id !== '')
     {
      
     var data={
       category_id:this.state.category_id,
       group_name:this.state.groupName
     };
   }
   else
   {
     var data={
       category_id:null,
       group_name:this.state.groupName
     };
   }
     var token=reactLocalStorage.get('accessToken');
     var ip=API_BASE_URL;
     var s2 = "localhost:3000";
     var apiBaseUrl;
   
       if(ip.includes(s2))
       {
         apiBaseUrl = API_BASE_URL + "/core/user/rest/contacts/createGroup";
       }
       else
       {
        apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/createGroup";
       }
     

     var headers = {
      'Content-Type': 'application/json',
      'token':token
       }
     axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
     {

     if(response.status === 200)
     {
     
 
        window.location="Group";


     }
     else if(response.status === 204){
     console.log("Something wrong");

     toast({
       type: 'error',
       title: i18n.t('error.label'),
       description:i18n.t('Something_wrong.label'),
       animation: 'bounce',
       time: 5000,

   });

     }
     else{
     console.log("Something wrong");
     toast({
       type: 'error',
       title: i18n.t('error.label'),
       description:i18n.t('Something_wrong.label'),
       animation: 'bounce',
       time: 5000,

   });

     }
     })
     .catch(function (error) {
     console.log(error);
     toast({
       type: 'error',
       title: i18n.t('error.label'),
       description:i18n.t('Something_wrong.label'),
       animation: 'bounce',
       time: 5000,

   });
     });
   }



   ////////////////////////////// from edit group //////////////////////
   EditGroup = event => {
     this.setState({modalOpenEditGroup:true})
    reactLocalStorage.set("id_user_edit_group", event.target.id);
    reactLocalStorage.get("id_user_edit_group");
    this.editGroup()
   
  };

  editGroup(){
    
    var token=reactLocalStorage.get('accessToken');
    var ip=API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if(ip.includes(s2))
    {
     apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/findAllCategories";     
    }
    else
    {
     apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/findAllCategories";
    }
  
    var headers = {'Content-Type': 'application/json', 'token' :token }
  axios.get(apiBaseUrl,{headers: headers})
     .then(res => {
  
       if(res.data.result.Categories !== undefined)
         {
           const dataoption=res.data.result.Categories;
           var length=res.data.result.Categories.length;
           var i;
           const newArr = [];
           for(i=0;i<length;i++)
           {
            var value_option=dataoption[i].category_name;
  
            newArr.push({
               label: value_option, 
               value:dataoption[i].id
           });
             
           }
           this.setState({groupName:this.state.groupName})
           countryOptions= newArr;
  
        }
      
      })
  
      var page=0;
      if(ip.includes(s2))
      {
       apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;     
      }
      else
      {
       apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;
      }
  
  
  
       headers = {'Content-Type': 'application/json', 'token' :token }
      axios.get(apiBaseUrl,{headers: headers})
          .then(res => {
            const persons = res.data.result.group;
            var array=[];
            if(persons !== undefined)
            {
              array.push({
                label:'',
                value:'null'
               })
               this.setState({group_id:res.data.result.group.group_id})
              this.setState({group_name:res.data.result.group.group_name})
              this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
              var total=Math.ceil(res.data.result.group.total_group_contacts / 10);
              this.setState({totalpage:total})
           
              if(res.data.result.group.total_group_contacts === 0)
              {
              
             // document.querySelector('.view_details_group').style = 'display:none';
              }
             this.setState({group_contact: res.data.result.group.group_contacts});
           
          
           this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
       
           const newArr=[]
           if(res.data.result.group.category !== null)
           { newArr.push({
             label: res.data.result.group.category.category_name, 
             value:res.data.result.group.category.category_id
         });
         if(res.data.result.group.category.category_name !== '') 
         {
           this.setState({name_category:res.data.result.group.category.category_name})
  
         }
         else{
            this.setState({name_category:'Select ...'})
         }
         value_options= newArr;
         this.setState({group_datas : res.data.result.group.category.category_id});
         group_data = res.data.result.group.category.category_id
           }
          
         
         this.setState({groupName:this.state.groupName})
   
            }
          }) 

  }
   searchchangepage=()=>{
    var id=reactLocalStorage.get('id_user_edit_group');
    var token=reactLocalStorage.get('accessToken');
    var ip=API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page=this.state.activePage -1;
    if(ip.includes(s2))
    {
     apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;     
    }
    else
    {
     apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;
    }
  
  
  
    var headers = {'Content-Type': 'application/json', 'token' :token }
    axios.get(apiBaseUrl,{headers: headers})
        .then(res => {
          const persons = res.data.result.group;
          var array=[];
          var i;
          if(persons !== undefined)
          {
            array.push({
              label:'',
              value:'null'
             })
             this.setState({group_id:res.data.result.group.group_id})
            this.setState({group_name:res.data.result.group.group_name})
            this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
            if(res.data.result.group.total_group_contacts === 0)
           
           this.setState({group_contact: res.data.result.group.group_contacts});
         
        
         this.setState({searchtotal_group_contacts:res.data.result.group.total_group_contacts,
        searchgroupcontacttotalpage: Math.ceil(res.data.result.group.total_group_contacts.length/20)})
     
  
          }
        }) 
   }

/*    handleChange = event => {
    this.setState({ groupName: event.target.value});

  } 
   
 */
  handleChangeEditGroup = event => {
    this.setState({ group_name: event.target.value});

  }

  onChange(values) {

   this.setState({
     selectedValues: values
   });
 }
 /* handleClick = (e, titleProps) => {
   const { index } = titleProps
   const { activeIndex } = this.state
   const newIndex = activeIndex === index ? -1 : index

   this.setState({ activeIndex: newIndex })
 }
  */

  
 handleSubmitEdit = event => {
  event.preventDefault();
  var id_user=this.state.id_user;
  var token=reactLocalStorage.get('accessToken');
if(this.state.group_datas )
{
 var user = {
    'group_name': this.state.group_name,
    'group_id':reactLocalStorage.get('id_user_edit_group'),
    'category':group_data,
  };
}
else {
var user = {
  'group_name': this.state.group_name,
  'group_id':reactLocalStorage.get('id_user_edit_group'),
  'category':'null',
};
}
  var data=user;

  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  if(ip.includes(s2))
  {
    apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/updateGroup";     
  }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/updateGroup";
  }


  var headers = {
   'Content-Type': 'application/json',
    'token' :token
    }
  axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
  {

  if(response.status === 200)
  {

     window.location="Group";
  

  }
  else if(response.status === 204){
    toast({
      type: 'error',
      title: i18n.t('error.label'),
      description:i18n.t('Something_wrong.label'),
      animation: 'bounce',
      time: 5000,

  });

  }
  
  })
  .catch(function (error) {
  console.log(error);
  toast({
    type: 'error',
    title: i18n.t('error.label'),
    description:i18n.t('Something_wrong.label'),
    animation: 'bounce',
    time: 5000,

});
  });
}

handlePaginationChange = (e, { activePage }) => {
  this.setState({ activePage })
var id=reactLocalStorage.get('id_user_edit_group');
var token=reactLocalStorage.get('accessToken');
var ip=API_BASE_URL;
var s2 = "localhost:3000";
var apiBaseUrl;
var page=activePage -1;
if(ip.includes(s2))
{
apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;     
}
else
{
apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/findAllContactsInGroup/"+reactLocalStorage.get('id_user_edit_group')+"/"+page;
}



var headers = {'Content-Type': 'application/json', 'token' :token }
axios.get(apiBaseUrl,{headers: headers})
.then(res => {
  const persons = res.data.result.group;
  var array=[];
  var i;
  if(persons !== undefined)
  {
    array.push({
      label:'',
      value:'null'
     })
     this.setState({group_id:res.data.result.group.group_id})
    this.setState({group_name:res.data.result.group.group_name})
    this.setState({total_group_contacts:res.data.result.group.total_group_contacts})
    if(res.data.result.group.total_group_contacts === 0)
    {
    
    document.querySelector('.view_details_group').style = 'display:none';
    }
   this.setState({group_contact: res.data.result.group.group_contacts});
 

 this.setState({total_group_contacts:res.data.result.group.total_group_contacts})


  }
}) }


onChangegroup =event=>{
  group_data='';
  group_data=event.value
  this.setState({group_datas : event.value})
}


export_details = event => {
  document.querySelector(".viewDetails").style =
  "display:block !important;";
  var x = this;
  var group_id = this.state.group_id;
  var token = reactLocalStorage.get("accessToken");
  var ip = API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  var collectionName = "corpsms_contacts_" + group_id;
  if (ip.includes(s2)) {
    apiBaseUrl =
      API_BASE_URL + "/core/user/rest/Export/" + collectionName;
  } else {
    apiBaseUrl =
      API_BASE_URL + "/core/user/rest/Export/" + collectionName;
  }
  var headers = {
    "Content-Type": "application/json",
    token: token
  };
    axios
    .get(apiBaseUrl, { headers: headers })
    .then(function(response) {
      if (response.status === 200) {
        if (
          response.data.status != "ready to download" ||
          response.data.status === "proccessing file" ||
          response.data.status === "Genrating File still in progress"
        ) {
          document.querySelector(".viewDetails").style =
            "display:block !important;";
            x.export_detailsInterval();
          x.setState({ viewData: response.data.status });
        } else if (response.data.status === "ready to download") {
          x.setState({ viewData: response.data.status });
          document.querySelector(".viewBox").style = "display:none";
          var collectionName = response.data.file_name;
          if (ip.includes(s2)) {
            window.location =
              API_BASE_URL + "/core/user/rest/Export/" +
              collectionName +
              "/download";
          } else {
            window.location =
              API_BASE_URL +
              "/core/user/rest/Export/" +
              collectionName +
              "/download";
          }
          document.querySelector(".viewDetails").style = "display:none";
        }
      } else if (response.status === 204) {
        console.log("Something wrong");
      } else {
        console.log("Something wrong");
      }
    })
    .catch(function(error) {
      console.log(error);
    });
};

export_detailsInterval = event => {
   var x = this;
   var group_id = this.state.group_id;
   var token = reactLocalStorage.get("accessToken");
   var ip = API_BASE_URL;
   var s2 = "localhost:3000";
   var apiBaseUrl;
   var collectionName = "corpsms_contacts_" + group_id;
   if (ip.includes(s2)) {
     apiBaseUrl =
       API_BASE_URL + "/core/user/rest/Export/" + collectionName;
   } else {
     apiBaseUrl =
       API_BASE_URL + "/core/user/rest/Export/" + collectionName;
   }
   var headers = {
     "Content-Type": "application/json",
     token: token
   };
   var callexport = setInterval(function(){
     axios
     .get(apiBaseUrl, { headers: headers })
     .then(function(response) {
       if (response.status === 200) {
         if (
           response.data.status != "ready to download" ||
           response.data.status === "proccessing file" ||
           response.data.status === "Genrating File still in progress"
         ) {
           document.querySelector(".viewDetails").style =
             "display:block !important;    margin-top: 37%;";
           x.setState({ viewData: response.data.status });
         } else if (response.data.status === "ready to download") {
           clearInterval(callexport);
           x.setState({ viewData: response.data.status });
           document.querySelector(".viewDetails").style = "display:none";
           var collectionName = response.data.file_name;
           if (ip.includes(s2)) {
             window.location =
               API_BASE_URL + "/core/user/rest/Export/" +
               collectionName +
               "/download";
           } else {
             window.location =
               API_BASE_URL +
               "/core/user/rest/Export/" +
               collectionName +
               "/download";
           }
           document.querySelector(".viewDetails").style = "display:none";
         }
       } else if (response.status === 204) {
         console.log("Something wrong");
       } else {
         console.log("Something wrong");
       }
     })
     .catch(function(error) {
       console.log(error);
     });
     },3000)
 };

exportData = e => {
  setInterval(this.exportDataTimer(), 5000);
};

exportDataTimer() {
 // document.querySelector(".viewBox").style = "display:block";
  var x = this;
  var user_id = reactLocalStorage.get("user_id_login");
  var group_id = reactLocalStorage.get("group_id");
  var token = reactLocalStorage.get("accessToken");
  var ip = API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  var collectionName = "corpsms_contacts_";
  var query = { 'groups.group_id': group_id };
 
  query = encodeURI(JSON.stringify(query));
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + `/core/user/rest/Export/${collectionName}${user_id}?query=${query}`
        
      
       
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/Export/${collectionName}${user_id}?query=${query}`
    }
    var headers = {
      "Content-Type": "application/json",
      token: token
    };
    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status != "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
            document.querySelector(".viewBox").style = "display:block";
            x.exportDataTimerInterval();
            x.setState({ viewData: response.data.status });
          } else if (response.data.status === "ready to download") {
            document.querySelector(".viewBox").style = "display:none";
            x.setState({ viewData: response.data.status });
            var collectionName = response.data.file_name;
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
                API_BASE_URL +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
}

exportDataTimerInterval() {
  var x = this;
  var user_id = reactLocalStorage.get("user_id_login");
  var group_id = reactLocalStorage.get("group_id");
  var token = reactLocalStorage.get("accessToken");
  var ip = API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  var collectionName = "corpsms_contacts_";
  if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
    var query = { group_id: user_id };
  } else {
    var query = { group_id: user_id };
  }
  query = encodeURI(JSON.stringify(query));
  var callexport = setInterval(function(){
    if (ip.includes(s2)) {
      apiBaseUrl =
      `${API_BASE_URL} + /core/user/rest/Export/${collectionName}${user_id}?query=${query}`
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/Export/${collectionName}${user_id}?query=${query}`
    }
    var headers = {
      "Content-Type": "application/json",
      token: token
    };
    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status != "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
            document.querySelector(".viewBox").style = "display:block";
            x.setState({ viewData: response.data.status });
          } else if (response.data.status === "ready to download") {
            clearInterval(callexport);
            document.querySelector(".viewBox").style = "display:none";
            x.setState({ viewData: response.data.status });
            var collectionName = response.data.file_name;
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
                API_BASE_URL +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
    },5000)
}


  render() {
    const { activePage,activePageGroup } = this.state;
    const { activeIndex } = this.state;

    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_category">
            <div className="category_main">
              <Grid columns={2} divided className="fixed_group">
                <Grid.Row stretched className="fixed_header" >
                  <Grid.Column className="grid_logo">
                    
                    <Segment>
                      <h3 className="text_style pink_color">
                        {this.state.isArabic?(
                      <img
                        src={require("../pictures/ArabicHedar.png")}
                        style={{width:'100% !important',height:'117px',marginTop:'8px',marginRight:'-13px'}}
                       className="himage"
                      />
                        ):(<img
                          src={require("../pictures/EnglishHedar.png")}
                          style={{width:'100% !important',height:'117px',marginLeft:'-13px',marginTop:'8px'}}
                          className="himage"
                        />)}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

             </div> </div>
             <br></br><br></br><br></br><br></br>
<div className="container_cards"  style={{paddingRight:this.state.isArabic? '':'20px'}}>

<div className={this.state.isArabic? 'content_reportarabic' :'content_report'}>
<br></br>
  <Segment color='black' style={{padding:'20px', minHeight:'200px'}} >
    <br></br>
              <Divider horizontal>
                  <Header as='h2'>
                  <Icon name='user outline' color='black' /> {this.state.isArabic?' دليل العناوين':'Address Book'}
                  </Header>
              </Divider>
                <br></br>
                
                <Step.Group widths={2} >
                <Step active>
                  <Icon name='users' onClick={()=>{window.location="group"}} />
                  <Step.Content>
                    <Step.Title>
                    <Header onClick={()=>{window.location="group"}}>  {  i18n.t("Groups.label")  } </Header>
                    </Step.Title>
                  </Step.Content>
                </Step>
                <Step >
                  <Icon name='list alternate outline'  onClick={()=>{window.location="category"}} />
                  <Step.Content>
                    <Step.Title>
                    <Header  onClick={()=>{window.location="category"}}>{i18n.t("Category.label")}</Header>
                    </Step.Title>
                  </Step.Content>
                </Step>
              </Step.Group>
             

                <br></br><br></br>
                <Button
                        floated={this.state.isArabic? 'left' :'right'}
                        icon
                        labelPosition='left'
                        basic
                        size='small'
                        onClick={this.AddGroup}
                      >
                       {this.state.isArabic? ' مجموعة جديدة ':' New Group'}
                        <Icon name='pencil alternate' color='black' ></Icon>
                     
              </Button>
              <br></br>  <br></br><br></br>
              <Table hover  responsive border="0" style={{textAlign:this.state.isArabic?'right':'left'}}  >
                  <thead className="head">
                  
                  <tr>
                    <td><Icon name='group'/>  {i18n.t("Group_Name.label")} </td>
                  
                    <td> {i18n.t("Category.label")}</td>
                    <td  style={{textAlign:'center'}}>{this.state.isArabic?'جهات اتصال المجموعة':'Group Contacts'}</td>
                    <td  style={{textAlign:'center'}}>{this.state.isArabic?'إعدادات':'Settings'}</td>

                  </tr>
                </thead>
              {this.state.groups.map(person => (
              
               
                   
                <tbody>
                  <tr>
                    <td >  {person.group_name}</td>
                
                    <td> {person.category.category_name} </td>
                    <td style={{textAlign:"center"}}> 
                    
                        <Icon name='eye' color='black'  className="eye" id={person.id}
                        onClick={this.findContactInGroup} ></Icon>
                     
         
                   
                            
         </td>

         <td style={{textAlign:'center'}}> 
                         
              <Header as="h6"  textAlign='center'>
                <Icon  name='add user'  className="eye" id={person.id} onClick={this.addContact}  ></Icon>
                  
                  <Icon name='attach'  className="eye" id={person.id} onClick={(event)=>{this.ImportGroup(event)}}></Icon>
                      
                  <Icon  name='edit outline'  className="eye" onClick={this.EditGroup} id={person.id}></Icon>
                  <Icon  name='trash alternate outline' className="eye" onClick={this.openModalDelete} id={person.id}></Icon>
                  </Header>
              
            
                  </td>

                  </tr>
                  </tbody>

                  ))}

              </Table>
           
                 
            
                
                
              

                <br></br>
                <br></br>

               
                  <Segment basic></Segment>
                     <Divider horizontal>
                  <Header as='h5'  floated={this.state.isArabic? 'left' :'right'}>
                  <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChangeGroup}
                        totalPages={this.state.totalpage}
                        className="page"
                        floated={this.state.isArabic?'left':'right'}
                        
                      />
                   
                    </Header>
                    <Header as='h5'  floated={this.state.isArabic? 'left' :'right'}>
                 
                    
                    </Header>
                    </Divider>
                 

                </Segment>
              </div>
              
            </div>
          </div>
         
        


        

        
        

        {/* /////////////////////////////////////////Modals/////////////////////////////////////// */}

                <Modal 
                 closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
                        open={this.state.modalOpenAddGroup}
                        onClose={this.handleCloseAddGroup}
                        size='small'
                      style={this.state.isArabic? modAdda :modAdd}
                        className='filter'
                         >
                <Header content={i18n.t('Add_Group.label')} />
                <Modal.Content>
                    <Form.Group  style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}} >
                      <Form.Input  fluid label= {i18n.t('Name_of_Group.label')} placeholder={i18n.t('Name_of_Group.label')} style={{width:'100%'}} onChange={this.handleChangeAddGroup} value={this.state.groupName} />
                     <br></br>
                     <Form.Field></Form.Field>
                      <Form.Field>


                  <label>{i18n.t('Select_Category.label')}</label>
                  <Select
                  placeholder={i18n.t('select.label')}
                  fluid
                  search
                  selection
                  options={categoryOptions}
                  onChange={this.onChangecategory.bind(this)}
                 
                />
                </Form.Field>
                  </Form.Group>
                </Modal.Content>
                <Modal.Actions>
                  <Button basic color='teal' content={i18n.t('Submit.label')} onClick={this.handleSubmitAddGroup} />
                  <Button basic color='black' content={i18n.t('Cancel.label')} onClick={this.handleCloseAddGroup} />
                </Modal.Actions>
              </Modal>




                <Modal size='tiny' 
                open={this.state.modalOpenImportFromContact}
                onClose={this.handleCloseImportFromContact}
                closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
                size='small' style={this.state.isArabic? modContacta :modContact} 
                className="filter">
                <Header content=  {i18n.t("Contact_List.label")} />
                <Modal.Content scrolling>
                <Header as='h5' floated='right'>
                <Input size='small' icon='search'  placeholder={this.state.isArabic?'البحث عن رقم الهاتف':'Search Phone Number'}  onChange={this.searchchange.bind(this)} />
                </Header>
                <br></br><br></br>
                <Form>

                <Table hover  responsive border="0" style={{textAlign:this.state.isArabic?'right':'left'}}  >
                <thead className="head">
                <tr>
                <td>  {i18n.t("Full_Name.label")}</td>
                <td>{i18n.t("Mobile_Number.label")}</td>
                <td>{this.state.isArabic?'اختر':'Select'}</td>
                </tr>
                </thead>
                <tbody>
                {this.state.personsContact.map(person => (
                <tr>
                <td>



                  {person.first_name} {" "} {person.second_name} {" "}
                  {person.family_name}

                </td>
                <td>{person.mobile_number}</td>
                <td ><Checkbox
                label=""
                style={{ width: "20%" }}
                onClick={this.addContactList}
                id={person.id}
                /></td>
                </tr>
                ))}
                </tbody>

                </Table>
                </Form>
                </Modal.Content>
                <Modal.Actions>
                <Button basic color='teal' content=  {i18n.t("Submit.label")} id={this.state.contactsIDs}
                onClick={this.sendAll} />
                <Button basic color='black' content=  {i18n.t("Cancel.label")} onClick={this.handleCloseImportFromContact} />
                </Modal.Actions>
                </Modal>



                <Modal 
                        open={this.state.modalOpenImportFromFile}
                        onClose={this.handleCloseImportFromFile}
                        closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
                        size='small' style={this.state.isArabic? modAdda :modAdd}
                        className="add">
                <Header icon='attach' content={i18n.t("Import.label")} />
                <Modal.Content>
                    <Form>
                    <a
                            style={{
                              float: this.state.isArabic ? "right" : ""
                            }}
                            href={require("../pictures/sample.csv")}
                            download
                            style={{
                             
                              color: "red",
                              cursor: "pointer",
                              fontSize:"15px",
                              fontWeight:"bold"
                            }}
                          >
                            {i18n.t("Click_to_download_sample.label")}
                          </a>
                          <br></br>
                      <Form.Input fluid  type="file" ref={input => {this.filesInput = input; }}  name="file"
                    labe={i18n.t("UploadCSV.label")} placeholder={i18n.t("UploadCSV.label")}
                    onChange={this.handleChangeFile} width={10} />

                  </Form>
                </Modal.Content>
                <Modal.Actions>
              <Button basic color='teal' content= {i18n.t("Submit.label")}  onClick={this.ImportGroupdata} id="group_import_btn" />
                      <Button basic color='black' content={i18n.t("Cancel.label")} onClick={this.handleCloseImportFromFile}  />
                </Modal.Actions>
                </Modal>




                <Modal size='tiny' 
                 closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
                        open={this.state.modalOpenEditGroup}
                        onClose={this.handleCloseEditGroup}
                        className="add"
                        size='small' style={this.state.isArabic? modEdita :modEdit}>
                <Header icon='edit outline' content={i18n.t('Edit_Group.label')} />
                <Modal.Content>
                
                      <Form.Input fluid label={i18n.t('Name_of_Group.label')} placeholder='Name of Group'  onChange={this.handleChangeEditGroup}
                                value={this.state.group_name}  style={{width:'100%'}} />
                    
                    <br></br>
                    <Form.Input fluid label={i18n.t('total_group_contacts.label')}  disabled
                        value={this.state.total_group_contacts}  required placeholder='Total Group Contacts' style={{width:'100%'}} />

                  <br></br>
                      <label
                            htmlFor="defaultFormCardNameEx"
                            className="grey-text font-weight-light"
                        >
                        
                        {i18n.t('Category.label')}
                        </label>
                        <Select
                          placeholder={this.state.name_category}
                          fluid
                          search
                          selection
                          options={countryOptions}
                          onChange={this.onChangegroup.bind(this)}
                         value={value_options}
                          className="sender_value"
                          id="sender_select"
                         
                        />
                       <br></br>
                  
              
              
                       </Modal.Content>
                <Modal.Actions >
                
                      <Button basic color='teal' content={i18n.t('Submit.label')} onClick={this.handleSubmitEdit} />
                      
                      <Button basic color='black' content={i18n.t('Cancel.label')} onClick={this.handleCloseEditGroup} />
               

                
                </Modal.Actions>
              
                </Modal>


                <Modal 
                 closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
                        open={this.state.modalOpenDeleteGroup}
                        onClose={this.handleCloseDeleteGroup}
                        size='small'   className="filter"    style={this.state.isArabic? modDeletea :modDelete} 
                        >
                <Header icon='trash' content={this.state.isArabic?'حذف المجموعة' :'Delete Group'}  />
                <Modal.Content>
                <Header as='h3' textAlign='center'>  {i18n.t("deleteAproval.label") +" ?"}</Header>
                </Modal.Content>
                <Modal.Actions>
              <Button basic color='teal' content={i18n.t("Yes.label")} id={this.state.contactsIDs}
              onClick={this.DeletGroup} />
                <Button basic color='black' content={i18n.t("No.label")} onClick={this.handleCloseDeleteGroup} />
                </Modal.Actions>
              </Modal>



        <Modal
         closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
        open={this.state.modalOpenGroupsContacts}
        onClose={this.handleCloseGroupsContacts}
         size='medium'
         className="filter"
        style={this.state.isArabic? modContacta :modContact}
      >
        <Header icon='eye' content= {this.state.isArabic?'جهات اتصال المجموعة':'Group Contacts'} />

        <Modal.Content>
                 <Button
                        floated={this.state.isArabic? 'left' :'right'}
                        icon
                        labelPosition='left'
                        basic
                        size='small'
                        onClick={this.exportData}
                        
                      >
                       {i18n.t('export.label')}
                        <Icon name='file excel' color='black' ></Icon>              
              </Button>

        <br></br><br></br>
        <Table hover  responsive border="0" style={{textAlign:this.state.isArabic?'right':'left'}}  >
                  <thead className="head">
         
            <tr>
            <td> {i18n.t('Full_Name.label')}</td>
              <td>{i18n.t('Mobile_Number.label')}</td>
              <td>{i18n.t('createdTime.label')}</td>
              <td>{i18n.t('country.label')}</td>
              <td>{i18n.t('company.label')}</td>
              <td>{i18n.t('district.label')}</td>
              
              <td>{i18n.t('custom_filter1.label')}</td>
            </tr>
          </thead>
          <tbody>
          { this.state.group_contact.map(person => 
            <tr>
              <td>
                <Header as='h4' image>
                  <Header.Content>
                    <Header.Subheader>{person.first_name} {person.second_name} {person.family_name}</Header.Subheader>
                  </Header.Content>
                 
                </Header>
              </td>
              <td>
                <Header as='h4' image>
                  <Header.Content>
                    <Header.Subheader>{person.mobile_number}</Header.Subheader>
                  </Header.Content>
                </Header>
              </td>
              <td>
                <Header as='h4' image>
                  <Header.Content>
                    <Header.Subheader>{person.createdTime}</Header.Subheader>
                  </Header.Content>
                </Header>
              </td>
                <td>
                <Header as='h4' image>
                  <Header.Content>
                    <Header.Subheader>{person.country}</Header.Subheader>
                  </Header.Content>
                </Header>
              </td>
                <td>
                <Header as='h4' image>
                  <Header.Content>
                    <Header.Subheader>{person.company}</Header.Subheader>
                  </Header.Content>
                </Header>
              </td>
                        <td>
                <Header as='h4' image>
                  <Header.Content>
                    <Header.Subheader>{person.district}</Header.Subheader>
                  </Header.Content>
                </Header>
              </td>
                        <td>
                <Header as='h4' image>
                  <Header.Content>
                    <Header.Subheader>{person.custom_filter1}</Header.Subheader>
                  </Header.Content>
                </Header>
              </td>
            </tr>
              )}
              
              </tbody>
        
              <tfoot>
                      <tr>
                        <td colSpan='7'>
                      
                          <Pagination
                        defaultActivePage={1}
                        activePage={activePage}
                        onPageChange={this.handlePaginationChange}
                       
                        totalPages={this.state.groupcontacttotalpage}
                        className="page_contact"
                      />
                      </td>
                     </tr>
                     </tfoot>
        
        </Table>
              </Modal.Content>
             
              <Modal.Actions>
                <Button secondary content={i18n.t('Close.label')} onClick={this.handleCloseGroupsContacts} />
              </Modal.Actions>
              <div className="viewBox" style={{ display: "none" }}>
              <Message icon className="download_box_request">
                <Icon name="circle notched" loading />
                <Message.Content>
                  <Message.Header>Wait for downloading</Message.Header>
                  {this.state.viewData}
                </Message.Content>
              </Message>
              </div>{" "}
            </Modal>



      </div>
    );
  }
}
const mapStateToProps = state => {
  return { ...state };
};
export default connect(mapStateToProps)(Group);